import { Dialog, DialogContent } from '@mui/material'

import React, { PropsWithChildren } from 'react'
import './custom-modal.scss'

interface CustomModalProps extends PropsWithChildren<any> {
    open: boolean
    _class?: string
}

const CustomModal: React.FC<CustomModalProps> = ({
    open,
    _class,
    children,
}) => {
    return (
        <Dialog open={open} maxWidth="md" className="dialog">
            <DialogContent className={_class ? _class : ''}>
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default CustomModal
